var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative applicant_profile_modal"},[(_vm.is_loading)?_c('div',{staticClass:"loading"}):_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.pdf_src,"width":"100%","height":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }